import { render, staticRenderFns } from "./OfertaListItem.vue?vue&type=template&id=35965799&scoped=true&"
import script from "./OfertaListItem.vue?vue&type=script&lang=js&"
export * from "./OfertaListItem.vue?vue&type=script&lang=js&"
import style0 from "./OfertaListItem.vue?vue&type=style&index=0&id=35965799&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35965799",
  null
  
)

export default component.exports